<template src="./reportsPage.html"></template>

<script>
    import {Sort} from "@syncfusion/ej2-vue-grids";

    export default {
        name: 'reports-page',
        data: function () {
            return {

            }
        },
        provide: {
            grid: [Sort]
        },
        methods: {

        },
        created() {

        },
        mounted() {

        }
    }
</script>
